<template>
<div class="chapter">
<div class="inner_page">
<div id="ded">
<br/><br/><br/><br/>
<p class="Body-NI">To my young and still innocent kids, Dominic and Victoria, I wrote this book to try to make sure you enter a workplace where you will be treated properly—reflective of the people you both are. We get such a short time on this planet. Being mistreated by your boss or anyone else for that matter should not be something you should have to worry about. It is my hope that you don’t ever have to go through some of the things I have had to witness and sometimes endure. To me, it would be a significant accomplishment for your boss to read this book and make the decision to CARE for you as I have tried to. What I hope and would love for both of you is to be CARE champions to all those you serve, as I have worked hard to be. Even if I didn’t win at this every time, I certainly did my very best to. Carry the CARE flag and make the world a little less stressful to live and work.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05-ded.vue?e467154c